<div cdkDrag cdkDragRootElement=".cdk-overlay-pane">
    <div mat-dialog-title class="matDialogTitle" cdkDragHandle>
        <mat-progress-bar mode="indeterminate" class="detaile" [hidden]="!loading"></mat-progress-bar>
        کالا و خدمات
        <span class="close" (click)="close()">
            <mat-icon>close</mat-icon>
        </span>
    </div>
</div>


<div mat-dialog-content class="matDialogContent">
    <div style="text-align: right;">
        <span>
            <button (click)="which(2)" [disabled]='next_status'><i class="fas fa-forward"></i></button>
            <button (click)="which(3)" [disabled]='pre_status'><i class="fas fa-backward"></i></button>
        </span>
    </div>
    <input class="search" (keyup)="get_material(2)" [(ngModel)]="search" autocomplete="off">
    <div class="content-body control-content-body" [ngClass]="{content_body_en:lang==2}"
        style='overflow-x:auto;direction:rtl;max-height:22rem;min-height:22rem'>
        <mat-table [dataSource]="dataSource" style='min-width:100%'
            class='table-scroll mat_table_fa_without_scroll mat_table_fa_without_scroll_bg not- pe1'
            [ngClass]="{mat_table_en_without_scroll:lang==2,en1:lang == 2}"
            [ngStyle]="{'direction': lang == 2 ? 'ltr' : 'rtl' }">
            <ng-container matColumnDef="row">
                <mat-header-cell *matHeaderCellDef style="max-width:30px">
                    #
                </mat-header-cell>
                <mat-cell *matCellDef="let x;let i = index" style="max-width:30px">{{ page_number_first+i }}</mat-cell>
            </ng-container>

            <ng-container matColumnDef="material">
                <mat-header-cell *matHeaderCellDef style="text-align: center !important;" class="right">
                    <span *ngIf="lang == 1">عنوان قطعه</span>
                    <span *ngIf="lang == 2">Material Name</span>
                </mat-header-cell>
                <mat-cell *matCellDef="let x" class="cursor right">
                    <span class="paddingRight">{{ x.wharehouse_material_title }}</span>
                </mat-cell>
            </ng-container>

            <ng-container matColumnDef="number">
                <mat-header-cell *matHeaderCellDef style="max-width:80px">
                    <span *ngIf="lang == 1">تعداد </span>
                    <span *ngIf="lang == 2">Inventory</span>
                </mat-header-cell>
                <mat-cell *matCellDef="let x" class="cursor" style="text-align: center;"
                    style="max-width:80px;padding:0px !important">
                    <input class=" wh-input input1" id="input1{{ x.wharehouse_material_id }}" [value]="1"
                        autocomplete="off">
                </mat-cell>
            </ng-container>

            <ng-container matColumnDef="weight">
                <mat-header-cell *matHeaderCellDef style="max-width:80px">
                    <span *ngIf="lang == 1">واحد </span>
                    <span *ngIf="lang == 2">---</span>
                </mat-header-cell>
                <mat-cell *matCellDef="let x" class="cursor" style="text-align: center;" style="max-width:80px">
                    {{ x.wharehouse_weight_title }}
                </mat-cell>
            </ng-container>

            <ng-container matColumnDef="cost">
                <mat-header-cell *matHeaderCellDef style="max-width:80px" [hidden]="ref == 'order' ">
                    <span *ngIf="lang == 1">قیمت به تومان</span>
                    <span *ngIf="lang == 2">Inventory</span>
                </mat-header-cell>
                <mat-cell *matCellDef="let x" class="cursor" style="text-align: center;"
                    style="max-width:80px;padding:0px !important" [hidden]="ref == 'order' ">
                    <input class="wh-input input1" id="cost1{{ x.wharehouse_material_id }}" autocomplete="off"
                        [value]="x.wharehouse_material_price | number">
                </mat-cell>
            </ng-container>

            <ng-container matColumnDef="place">
                <mat-header-cell *matHeaderCellDef style="max-width:120px">
                    <span *ngIf="lang == 1">انتخاب انبار</span>
                    <span *ngIf="lang == 2">Inventory</span>
                </mat-header-cell>
                <mat-cell *matCellDef="let x" class="cursor" style="text-align: center;"
                    style="max-width:120px;padding:0px !important">
                    <select class="wh-input" id="place{{ x.wharehouse_material_id }}" readonly style="direction:rtl">
                        <option *ngFor="let y of list_place" [value]="y.wharehouse_place_id "
                            [selected]="x.wharehouse_place_id">
                            {{ y.wharehouse_place_title }}
                        </option>
                    </select>
                </mat-cell>
            </ng-container>

            <ng-container matColumnDef="add">
                <mat-header-cell *matHeaderCellDef style="max-width:80px">
                    <span *ngIf="lang == 1">اضافه کردن</span>
                    <span *ngIf="lang == 2">Inventory</span>
                </mat-header-cell>
                <mat-cell *matCellDef="let x;let i = index" class="cursor" style="text-align: center;"
                    style="max-width:80px;padding-top:3px !important">
                    <mat-icon class="add_circle_outline" (click)="save(i,x.wharehouse_material_id , 1 , 1 , 0)"
                        style="vertical-align: middle;font-size: 20px;">
                        add_circle_outline
                    </mat-icon>
                </mat-cell>
            </ng-container>

            <mat-header-row *matHeaderRowDef="displayedColumns" color="primary"></mat-header-row>
            <mat-row *matRowDef="let x;let i = index;columns:displayedColumns"></mat-row>
        </mat-table>

    </div>
    <!-- **************************************************************************************************** -->
</div>